import React from 'react';
import {SETTINGS as correctAnswerSettings} from 'client/Assignments/constants';
import {Checkbox, SelectField, TextAreaField, NumberInput, Text, Label} from '@albert-io/atomic';

import '../settings-modal.scss';

interface Props {
  hasTimeLimit: boolean;
  setHasTimeLimit: (boolean) => void;
  timeLimit: number | null;
  setTimeLimit: (string) => void;
  showExplanationsOption: string;
  setShowExplanationsOption: (string) => void;
  message: string;
  setMessage: (string) => void;
  allowLateSubmissions: boolean;
  setAllowLateSubmissions: (boolean) => void;
  randomizeQuestionOrder: boolean;
  setRandomizeQuestionOrder: (boolean) => void;
}

const correctAnswerSettingsMap = {
  'After each question': correctAnswerSettings.SHOW_AFTER_EACH,
  'After assignment completion': correctAnswerSettings.SHOW_AFTER_ALL,
  'After due date has passed': correctAnswerSettings.SHOW_AFTER_DUE_DATE
};

const GeneralSettings = ({
  hasTimeLimit,
  setHasTimeLimit,
  timeLimit,
  setTimeLimit,
  allowLateSubmissions,
  setAllowLateSubmissions,
  randomizeQuestionOrder,
  setRandomizeQuestionOrder,
  showExplanationsOption,
  setShowExplanationsOption,
  message,
  setMessage
}: Props) => {
  const options = Object.keys(correctAnswerSettingsMap).map((setting) => ({
    value: setting,
    disabled: false
  }));

  return (
    <div className='general-settings__container'>
      <Label>
        <Checkbox
          aria-hidden={false}
          size='s'
          onClick={() => setHasTimeLimit(!hasTimeLimit)}
          className='u-mar-r_1'
        />
        Set time limit
        {hasTimeLimit && (
          <>
            <NumberInput
              aria-label='Time'
              onChange={(e) => {
                const value = e.target.value === '' ? null : parseInt(e.target.value, 10);
                setTimeLimit(value);
              }}
              value={timeLimit}
              min={1}
              size='s'
              className='general-settings__time-limit-input u-mar-l_2 u-mar-r_1'
            />
            <Text>minutes</Text>
            {timeLimit === 0 && (
              <Text color='red' className='u-mar-l_3'>
                Must be 1 minute or greater.
              </Text>
            )}
          </>
        )}
      </Label>
      <Label>
        <Checkbox
          aria-hidden={false}
          size='s'
          onClick={() => setAllowLateSubmissions(!allowLateSubmissions)}
          className='u-mar-r_1'
        />
        Allow late submissions
      </Label>
      <Label>
        <Checkbox
          aria-hidden={false}
          size='s'
          onClick={() => setRandomizeQuestionOrder(!randomizeQuestionOrder)}
          className='u-mar-r_1'
        />
        Randomize the order of questions for each student
      </Label>
      <SelectField
        className='general-settings__show-explanations-select-field'
        border
        label='Show correct answers and explanations'
        options={options}
        onChange={(e) => {
          setShowExplanationsOption(correctAnswerSettingsMap[e.target.value]);
        }}
      />
      <TextAreaField
        placeholder='Text'
        size='l'
        type='text'
        label='Message (Optional)'
        onChange={(e) => {
          setMessage(e.target.value);
        }}
      />
    </div>
  );
};

export default GeneralSettings;
